import React from "react";
import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import GPAP_Button from "../../../../../gpap-lib/Button_Collection";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";


/* Select Owner according to errors*/
const ActionsGrid = (props) =>{
    return(
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
        >
            <Grid item>
                <Tooltip title="Owner Icon">
                    <IconButton aria-label="Owner">
                       <AccountCircleIcon/>
                    </IconButton>
                </Tooltip>
            </Grid>
        
            <Grid item>
                <FormControl fullWidth>
                    <InputLabel id="select-action-label">Actions</InputLabel>
                    <Select
                        labelId="select-action-label"
                        id="select-action"
                        value={props.actionSelected}
                        label="Actions"
                        onChange={props.handleSelectChange}
                        sx={{ maxHeight: 35, minWidth: 200 }}
                    >
                        {props.actions.map((action, key) => {
                            return <MenuItem key={key} value={action.value}>{action.name}</MenuItem>;
                        })}
                    </Select>
                </FormControl>
            </Grid> 
            
            <Grid item>
                { (props.actionSelected !== "unselected" &&  props.experimentsSelected>0) ? 
                    <Link to={props.to} 
                          style={{ textDecoration: 'none' }}>
                        <GPAP_Button> APPLY</GPAP_Button>
                    </Link>
                :  
                    <GPAP_Button disabled={true}>APPLY</GPAP_Button>
                }
            </Grid>

            <Grid item>
                {
                    (props.experimentsSelected > 0) ?
                        <Badge badgeContent={props.experimentsSelected} color="primary">
                            <Box component="span" sx={{ width: 190, height: 37, border: 1,
                                                  borderRadius: '6px', borderColor: 'primary.main' }}>
                                <Typography align='center' sx={{ mt: 0.6 }}> 
                                    Experiments Selected
                                </Typography>
                            </Box>                
                        </Badge>
                     :
                        null
                }
            </Grid>
        </Grid>
    );
}

export default ActionsGrid;

